import color from 'color';
import cloneDeep from 'lodash/cloneDeep';
import { ALL_HUMAN_AVATAR_COLOR_TYPES, ALL_HUMAN_AVATAR_PART_TYPES, DEFAULT_AVATAR_PROPERTIES_SET, HUMAN_AVATAR_PART_DEFINITIONS } from '../../types/avatarTypes';
import { secureRandom } from '../../utils/randomUtils';
import { range } from '../../utils/utils';
import { ALLOWED_LUMINOSITY_THRESHOLD } from './avatarColors/colorPickerGroupDisplay';
import { COLOR_GROUPS } from './avatarColors/colorPickerModal';
const ALL_AVAILABLE_COLORS = COLOR_GROUPS.map((colorGroup) => colorGroup.colors)
    .flat()
    // To avoid the possibility that the random color combinations would be "not allowed" because they are both very dark,
    // filter out the darkest colors from random selection:
    .filter((colorNum) => color(colorNum).luminosity() > ALLOWED_LUMINOSITY_THRESHOLD)
    .map((colorNum) => color(colorNum).hex());
function getRandomPartIndex(avatarPartTypeDefinition, currentIndex) {
    const { imageUrls, optionalProperties } = avatarPartTypeDefinition;
    if (imageUrls.length < 2) {
        // shouldn't happen, but avoid an infinite loop if for some reason there is only one option for this avatar part
        return 0;
    }
    const possibleIndexes = range(imageUrls.length);
    let newIndex;
    do {
        if (optionalProperties && secureRandom() < optionalProperties.randomChanceOfNone) {
            // part is off, based on the defined random chance for this part
            newIndex = -1;
        }
        else {
            newIndex = possibleIndexes[Math.floor(secureRandom() * possibleIndexes.length)];
        }
    } while (newIndex === currentIndex); // retry until newIndex is different than currentIndex
    return newIndex;
}
export function getRandomHumanAvatarProperties() {
    const humanAvatarProperties = cloneDeep(DEFAULT_AVATAR_PROPERTIES_SET.properties);
    ALL_HUMAN_AVATAR_PART_TYPES.forEach((partType) => {
        humanAvatarProperties.parts[partType] = { index: getRandomPartIndex(HUMAN_AVATAR_PART_DEFINITIONS[partType]) };
    });
    ALL_HUMAN_AVATAR_COLOR_TYPES.forEach((colorType) => {
        humanAvatarProperties.colors[colorType] =
            ALL_AVAILABLE_COLORS[Math.floor(secureRandom() * ALL_AVAILABLE_COLORS.length)];
    });
    if (secureRandom() < 0.25) {
        humanAvatarProperties.parts.mouth.subType = 'lipstick';
    }
    return humanAvatarProperties;
}
